import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "navigation-data",
  "use": "navigation-data-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"navigation-data\"><path clip-rule=\"evenodd\" d=\"M12 9.95c6.213 0 11.25-2.014 11.25-4.5 0-2.484-5.037-4.5-11.25-4.5S.75 2.967.75 5.45c0 2.486 5.037 4.5 11.25 4.5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M.75 5.45v6.75c0 2.485 5.037 4.5 11.25 4.5s11.25-2.014 11.25-4.5V5.45\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M.75 12.2v6.75c0 2.485 5.037 4.5 11.25 4.5s11.25-2.015 11.25-4.5V12.2\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/navigation-data.svg
// module id = 9To3
// module chunks = 39 44